import React, { useEffect, useRef } from "react";

import Modal from "./elements/Modal";

function InformationCreditsModal({ isOpenModal, setIsOpenModal }) {
	const closeButtonRef = useRef(null);
	const dialogRef = useRef(null);

	useEffect(() => {
		if (!isOpenModal) return undefined;
		const previouslyFocused = document.activeElement;
		const handleKeyDown = (event) => {
			if (event.key === "Escape") {
				setIsOpenModal(false);
				return;
			}
			if (event.key !== "Tab") return;
			const focusable = Array.from(dialogRef.current?.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			) || []).filter((element) => !element.disabled);
			if (!focusable.length) return;
			const first = focusable[0];
			const last = focusable[focusable.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		window.setTimeout(() => closeButtonRef.current?.focus(), 0);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
			previouslyFocused?.focus?.();
		};
	}, [isOpenModal, setIsOpenModal]);

	return (
		<Modal isOpen={isOpenModal} className="Modal__sponsor-container">
			<section ref={dialogRef} className="sponsor-modal" role="dialog" aria-modal="true" aria-labelledby="credit-information-title">
				<header className="sponsor-modal__header">
					<p>Credit information</p>
					<button ref={closeButtonRef} type="button" className="sponsor-modal__close" onClick={() => setIsOpenModal(false)} aria-label="Close credit information">
						<i className="fa fa-times" aria-hidden="true" />
					</button>
				</header>
				<div className="sponsor-modal__content">
					<h2 id="credit-information-title" className="article-title center">How credits work</h2>
					<h3 className="article-title">Membership</h3>
					<p className="article-text">Membership credits are added each month and accumulate while your subscription remains active.</p>
					<p className="article-text">You can hold more than one subscription. Billing frequency changes when you pay, not how frequently credits are added.</p>

					<h3 className="article-title">Credit packs</h3>
					<p className="article-text">Credit packs are one-time purchases. Pack credits normally expire one year after purchase.</p>
					<p className="article-text">If you have an active subscription when pack credits reach their expiry date, they remain available while that subscription stays active.</p>
				</div>
			</section>
		</Modal>
	);
}

export default InformationCreditsModal;
